import { translate as t } from "./locale";
export const ProjectCount = ({ count, limit }: { count: number; limit: number }) => (
    <p className="project-count">{t("Projekty:")} {count} / {limit}</p>
);
